const dateOptionsWithoutTime: any = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
};

export default class DateFormatter {
    private targetElement: ParentNode;
    constructor(targetElement: ParentNode = document) {
        this.targetElement = targetElement;
        this.formatDates(this.collectDates());
    }

    private collectDates(): Element[] {
        return Array.from(this.targetElement.querySelectorAll('[data-format-date]'));
    }

    private formatDates(dateElements: Element[]): void {
        dateElements.forEach(e => {
            const element = e as HTMLElement;
            const dateString = element.dataset.formatDate;
            const date = new Date(dateString)
            if (!this.isValidDate(date) && element.dataset.dateFallback) {
                element.textContent = element.dataset.dateFallback;
            }
            element.textContent = date.toLocaleString();
        });
    }

    private isValidDate(date: Date): boolean {
        if (Object.prototype.toString.call(date) !== "[object Date]")
            return false;

        if (isNaN(date.getTime()))
            return false;

        return true;
    }
}
